import React from 'react';

function Loader(){
    return (
        <p className='text-center'>Loading...</p>
    )
}

export default Loader